/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckAIcon64Regular = forwardRef('CheckAIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M56.518 15.44a1.5 1.5 0 0 1 0 2.12l-27.33 27.33a7.85 7.85 0 0 1-11.101 0L7.939 34.744a1.5 1.5 0 1 1 2.122-2.12l10.147 10.146a4.85 4.85 0 0 0 6.859 0l27.33-27.33a1.5 1.5 0 0 1 2.121 0Z" })));
});
